import { API } from "../../config";

const request = async (path, body) => {
  const response = await fetch(`${API}/intention${path}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.detail || "The journey could not continue");
  return data;
};

export const startIntentionJourney = (deviceId) => request("/start", { device_id: deviceId });

export const streamIntentionResult = async (payload, onStatus) => {
  const response = await fetch(`${API}/intention/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.detail || "Your intention could not be formed yet");
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let finalResult = null;
  while (true) {
    const { done, value } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const packets = buffer.split("\n\n");
    buffer = packets.pop() || "";
    packets.forEach((packet) => {
      const line = packet.split("\n").find((item) => item.startsWith("data: "));
      if (!line) return;
      const event = JSON.parse(line.slice(6));
      if (event.type === "status") onStatus(event.message);
      if (event.type === "error") throw new Error(event.message);
      if (event.type === "result") finalResult = event;
    });
  }
  if (!finalResult) throw new Error("Your intention could not be formed yet");
  return finalResult;
};

export const requestRewardCode = (payload) => request("/reward/request", payload);
export const claimRewardCode = (payload) => request("/reward/claim", payload);
export const getRewardStatus = (payload) => request("/reward/status", payload);